/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/StringComparison',[], function () {
    "use strict";


    var StringComparison = {
        OrdinalIgnoreCase: "OrdinalIgnoreCase",

        StartsWith: function (s, prefix, compareType) {
            if (compareType == StringComparison.OrdinalIgnoreCase) {
                return s.toLowerCase().indexOf(prefix.toLowerCase()) == 0;
            }
            else {
                return s.indexOf(prefix) == 0;
            }
        }

    };

    return StringComparison;

});
